import React from 'react';
import ContentCard from './ContentCard';
import Icon from '../../../components/AppIcon';

const ResultsGrid = ({ results, onPlay, onSave, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="results-loading flex flex-col items-center justify-center py-16">
        <div className="w-16 h-16 rounded-full border-4 border-primary/20 border-t-primary animate-spin mb-4"></div>
        <p className="text-sm text-muted-foreground">Загрузка результатов...</p>
      </div>
    );
  }

  if (!results || results?.length === 0) {
    return (
      <div className="results-empty flex flex-col items-center justify-center py-16 bg-card border border-border rounded-lg">
        <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mb-4">
          <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
          Ничего не найдено
        </h3>
        <p className="text-sm text-muted-foreground text-center max-w-md">
          Попробуйте изменить параметры поиска или фильтры для получения результатов
        </p>
      </div>
    );
  }

  return (
    <div className="results-grid">
      <div className="results-header flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading font-semibold text-foreground">
          Результаты поиска
          <span className="ml-2 text-muted-foreground font-normal">
            ({results?.length})
          </span>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {results?.map((content) => (
          <ContentCard
            key={content?.id}
            content={content}
            onPlay={onPlay}
            onSave={onSave}
          />
        ))}
      </div>
    </div>
  );
};

export default ResultsGrid;